import React, { useEffect, useState } from "react";
import { paymentStatus } from "../../redux/slices/payment/thunk";
import { useDispatch, useSelector } from "react-redux";
import { addOneOrder } from "../../redux/slices/orders/thunk";
import { useLocation, useSearchParams, useNavigate } from "react-router-dom";
import { FaExclamationTriangle } from "react-icons/fa"; // FontAwesome warning icon
import { addNewDeposite } from "../../redux/slices/deposites/thunk";

const SendOrderSuccessfully = () => {
  const invoiceId = localStorage.getItem("invoiceId");
  const orderData = JSON.parse(localStorage.getItem("orderDataJson"));
  const offerJson = JSON.parse(localStorage.getItem("offerJson"));
  const loggedUser = JSON.parse(localStorage.getItem('user'));
  console.log("offerJson",offerJson)
  console.log("orderData",orderData)

  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  
  const paymentStatusResponse = useSelector(state => state.paymentReducer.paymentStatusResponse);
  // const isLoading = useSelector((state) => state.ordersReducer.isLoading);
  const isLoading = false

  console.log("isLoading",isLoading)
  const dispatch = useDispatch();
  const [searchParams, setSearchParams] = useSearchParams();
  const counter = parseInt(searchParams.get('counter'), 10); 



  const containerStyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '100vh',
    backgroundColor: '#f4f4f4',
    padding: '20px'
  };

  const messageBoxStyle = {
    width: '100%',
    maxWidth: '500px',
    backgroundColor: '#fff',
    fontFamily: "'Cairo', sans-serif",
    fontSize: '1rem',
    fontWeight: '700',
    height: '200px',
    border: '2px solid #000',
    borderRadius: '8px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    padding: '20px',
    color: '#333'
  };

  const spinnerStyle = {
    border: "8px solidrgb(255, 255, 255)",
    borderTop: "8px solid #3498db",
    borderRadius: "50%",
    width: "200px",
    height: "200px",
    animation: "spin 2s linear infinite",
    margin: "80px auto 0 auto"
  };

  const headingStyle = { marginBottom: '10px' };
  const paragraphStyle = { marginTop: '0', color: '#666' };


  const spinnerAnimation = `@keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }`;

  useEffect(() => {
    const fetchPaymentStatus = async () => {
      console.log("123123")
      if (invoiceId) {
        const data = { key: invoiceId};
        console.log("mokhtarTest")
        try {
          console.log("data",data)
          await dispatch(paymentStatus({ data }));
        } catch (err) {
          setError('Failed to fetch payment status.');
        } finally {
          setLoading(false);
        }
      } else {
        setLoading(false);
      }
    };
    fetchPaymentStatus();
  }, [invoiceId, dispatch]);

  useEffect(() => {
    if (paymentStatusResponse) {
      const invoiceStatus = paymentStatusResponse?.Data?.InvoiceStatus;

      if (invoiceStatus === "Paid" && orderData && counter !== 1) {
        dispatch(addOneOrder({ data: orderData }));
        let data = {
          user_id: orderData?.user,
          operation_type:"680a53566799fa8e9ccbc22f",
          adapter_name: orderData?.requestCard[0]?.name,
          price: offerJson?.offer?.reducedAmount,
          // deviceNumber: deviceNumber,
          operation_date: new Date(),
          // account_number_for_client: clientBankNumber,
          deposit_date: new Date() 
        };
       dispatch(addNewDeposite({ data }));

        setSearchParams({ counter: 1 }); // Prevents re-triggering on reload
      }
    }
  }, [paymentStatusResponse, orderData, counter, dispatch, setSearchParams]);

  useEffect(() => {
    if (!loading && paymentStatusResponse?.Data?.InvoiceStatus === "Paid" && loggedUser) {
      setTimeout(() => {
        navigate("/orders");
      }, 2000);
    }
  }, [loading, paymentStatusResponse, loggedUser, navigate]);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>{error}</div>;
  }

  return (
    <div>
{ isLoading ?  <div style={containerStyle}>
  {/* Spinner animation */}
  <style>{spinnerAnimation}</style>
  <div style={{ textAlign: "center", color: "#FFCC00", position: "relative" }}>
    {/* Spinner */}
    <div style={spinnerStyle}></div>

    {/* Icon fixed in place */}
    <FaExclamationTriangle
      size={120}
      style={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        zIndex: 1, // Ensures the icon stays on top of the spinner
      }}
    />
    <h2 style={{ marginTop: "20px", color: "#333", fontWeight: "700" }}>
      تمت عملية الدفع بنجاح، جاري إنشاء الطلب. يرجى عدم إغلاق الصفحة حتى اكتمال العملية.
    </h2>
  </div>
</div>


      : <div style={containerStyle}>
      <div style={messageBoxStyle}>
        {paymentStatusResponse?.Data?.InvoiceStatus === "Paid" ? (
          <>
            <h1 style={headingStyle}>تم ارسال الطلب بنجاح</h1>
            {/* <p style={paragraphStyle}>Your order has been successfully sent</p> */}
          </>
        ) : (
          <h1 style={headingStyle}>لم يتم تأكيد الدفع</h1>
        )}
      </div>
    </div>
       }
    
    </div>
  );
};

export default SendOrderSuccessfully;
